import { STATUS_ORDER } from "@/lib/data";
import { useLang } from "@/lib/i18n";

export default function StatusLine({ current = "driver_on_the_way", dark = false, testId = "status-line" }) {
  const { t } = useLang();
  const labels = t("statuses");
  const activeIdx = STATUS_ORDER.indexOf(current);

  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-2.5" data-testid={testId}>
      {STATUS_ORDER.map((id, i) => {
        const done = i < activeIdx;
        const active = i === activeIdx;
        return (
          <span key={id} className="flex items-center gap-3">
            <span className="flex items-center gap-2">
              <span className="relative flex h-2 w-2">
                {active && <span className="ping-soft absolute inline-flex h-full w-full rounded-full bg-miles" />}
                <span className={`relative inline-flex h-2 w-2 rounded-full transition-colors duration-500 ${
                  done || active ? "bg-miles" : dark ? "bg-white/25" : "bg-ink/15"
                }`} />
              </span>
              <span className={`text-xs font-semibold transition-colors duration-500 ${
                active ? (dark ? "text-white" : "text-ink")
                  : done ? (dark ? "text-white/70" : "text-ink/60")
                  : dark ? "text-white/35" : "text-ink/35"
              }`}>
                {labels[id]}
              </span>
            </span>
            {i < STATUS_ORDER.length - 1 && (
              <span className={`hidden h-px w-5 sm:block ${done ? "bg-miles" : dark ? "bg-white/15" : "bg-ink/10"}`} />
            )}
          </span>
        );
      })}
    </div>
  );
}
